import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest } from '../generalRequest';

const initialState = {
    exchanges : [],
    isLoading: false,
}

export const exchangeSlice = createSlice({
    name: 'exchange',
    initialState,
    reducers:{
        setIsLoading: (state,action) => 
        {
            state.isLoading = action.payload
        },
        setExchanges: (state,action) => 
        {
            state.exchanges = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(sendGeneralRequest.pending, (state) => {
            state.isLoading = true
        }) 
        .addCase(sendGeneralRequest.rejected, (state) => {
            state.isLoading = false
        }) 
        .addCase(sendGeneralRequest.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.endpoint === 'ShowExchange')
                {
                    state.exchanges = action.payload.response.data
                }
        })
    }
})

export const {setIsLoading, setExchanges} = exchangeSlice.actions
export const selectExchangeState = (state) => state.exchange
export default exchangeSlice.reducer